var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.751,
    height: 38.758,
    viewBox: "0 0 38.751 38.758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document",
    transform: "translate(0 512.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M3.076-511.972a4.18,4.18,0,0,0-2.962,3c-.1.417-.114,2.6-.114,16.144,0,14.493.008,15.69.129,15.887a.8.8,0,0,0,.3.3c.129.061,2.977.083,9.561.083h9.379l.038.735A2.328,2.328,0,0,0,20.7-473.6l.477.258H37.008l.477-.258a2.206,2.206,0,0,0,1.061-1.1l.2-.386v-20.682l-.258-.477a2.324,2.324,0,0,0-1.144-1.091l-.341-.174-4.75-.023-4.758-.023v-6.432h2.841c3.129,0,3.258-.015,3.477-.447a20.143,20.143,0,0,0,.008-4.546,4.163,4.163,0,0,0-3.008-3C30.122-512.146,3.758-512.139,3.076-511.972Zm23.319,1.9c-.53.886-.561,1.25-.561,7.424v5.091l-2.326.023c-2.311.023-2.341.023-2.712.212a2.666,2.666,0,0,0-1.174,1.174l-.189.379-.023,8.8-.015,8.811H1.591l.015-15.212.023-15.2.212-.455a2.9,2.9,0,0,1,.455-.7,2.857,2.857,0,0,1,1.242-.689c.159-.038,5.379-.068,11.7-.076L26.66-510.5Zm4.53-.152a2.384,2.384,0,0,1,1.189,1.227c.189.4.2.492.22,1.879l.03,1.462H27.5v-1.439a5.051,5.051,0,0,1,.144-1.818A2.376,2.376,0,0,1,30.925-510.222Zm5.78,14.387c.523.25.492-.439.492,10.409,0,8.758-.015,9.811-.121,10.038-.242.515.182.492-7.985.492s-7.743.023-7.985-.492c-.106-.227-.121-1.28-.121-10.038,0-8.743.015-9.818.121-10.038.242-.515-.189-.492,7.97-.492C35.645-495.957,36.485-495.941,36.705-495.835Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M64.882-415.891a.819.819,0,0,0-.106,1.455c.136.061,2.538.083,8.508.083,8.227,0,8.326,0,8.515-.152a.784.784,0,0,0,.25-.932c-.22-.538.348-.508-8.811-.5C68.708-415.936,64.943-415.913,64.882-415.891Z",
    transform: "translate(-59.504 -88.877)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M64.477-362.89a.884.884,0,0,0-.477.72.88.88,0,0,0,.492.727c.22.091,1.538.106,8.417.106,9.038,0,8.53.03,8.773-.492a.568.568,0,0,0,0-.682c-.242-.523.265-.492-8.8-.492C66.1-363,64.682-362.981,64.477-362.89Z",
    transform: "translate(-59.151 -137.801)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M64.747-308.847a.826.826,0,0,0-.129,1.28l.2.182,5.9.023c6.576.023,6.258.045,6.477-.492a.784.784,0,0,0-.25-.932c-.189-.151-.288-.151-6.114-.144C66.9-308.931,64.861-308.9,64.747-308.847Z",
    transform: "translate(-59.497 -187.776)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M64.882-255.885a.819.819,0,0,0-.106,1.455c.136.061,1.9.083,6.083.083,5.8,0,5.9,0,6.091-.152a.784.784,0,0,0,.25-.932c-.22-.53.083-.508-6.386-.5C67.617-255.931,64.943-255.908,64.882-255.885Z",
    transform: "translate(-59.504 -236.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M64.477-202.888a.884.884,0,0,0-.477.72.88.88,0,0,0,.492.727c.22.091,1.212.106,5.993.106,6.349,0,6.106.015,6.349-.492a1.155,1.155,0,0,0,.121-.341,1.156,1.156,0,0,0-.121-.341c-.242-.515.008-.492-6.371-.492C65.742-202.994,64.674-202.979,64.477-202.888Z",
    transform: "translate(-59.151 -285.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M64.747-148.847a.826.826,0,0,0-.129,1.28l.2.182,5.9.023c6.576.023,6.258.045,6.477-.492a.784.784,0,0,0-.25-.932c-.189-.152-.288-.152-6.114-.144C66.9-148.931,64.861-148.9,64.747-148.847Z",
    transform: "translate(-59.497 -335.655)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M299.22-276.78l-.22.22v7.152l.22.22.22.22h12l.22-.22.22-.22v-7.152l-.22-.22-.22-.22h-12Zm11.068,3.8v2.424h-9.7v-4.849h9.7Z",
    transform: "translate(-276.348 -217.29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M299.152-148.78a.8.8,0,0,0,.159,1.242,5.243,5.243,0,0,0,2.424,0,.8.8,0,0,0,.159-1.242l-.22-.22h-2.3Z",
    transform: "translate(-276.281 -335.593)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M363.152-148.78a.8.8,0,0,0,.159,1.242,5.243,5.243,0,0,0,2.424,0,.8.8,0,0,0,.159-1.242l-.22-.22h-2.3Z",
    transform: "translate(-335.432 -335.593)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M427.152-148.78a.8.8,0,0,0,.159,1.242,5.243,5.243,0,0,0,2.424,0,.8.8,0,0,0,.159-1.242l-.22-.22h-2.3Z",
    transform: "translate(-394.584 -335.593)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M299.485-106.883a.762.762,0,0,0-.485.727c0,.621.4.833,1.591.833s1.591-.212,1.591-.833a.748.748,0,0,0-.5-.727A5.793,5.793,0,0,0,299.485-106.883Z",
    transform: "translate(-276.348 -374.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M363.485-106.883a.762.762,0,0,0-.485.727c0,.621.4.833,1.591.833s1.591-.212,1.591-.833a.748.748,0,0,0-.5-.727A5.793,5.793,0,0,0,363.485-106.883Z",
    transform: "translate(-335.5 -374.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M427.485-106.883a.761.761,0,0,0-.485.727c0,.621.4.833,1.591.833s1.591-.212,1.591-.833a.748.748,0,0,0-.5-.727A5.793,5.793,0,0,0,427.485-106.883Z",
    transform: "translate(-394.651 -374.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M299.282-63.871a.811.811,0,0,0-.144,1.242l.22.22h2.3l.22-.22a.824.824,0,0,0,.114-.985c-.174-.326-.409-.386-1.508-.386C299.691-64,299.448-63.97,299.282-63.871Z",
    transform: "translate(-276.266 -414.153)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M363.282-63.871a.811.811,0,0,0-.144,1.242l.22.22h2.3l.22-.22a.824.824,0,0,0,.114-.985c-.174-.326-.409-.386-1.508-.386C363.691-64,363.448-63.97,363.282-63.871Z",
    transform: "translate(-335.418 -414.153)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M427.282-63.871a.811.811,0,0,0-.144,1.242l.22.22h2.3l.22-.22a.824.824,0,0,0,.114-.985c-.174-.326-.409-.386-1.508-.386C427.691-64,427.448-63.97,427.282-63.871Z",
    transform: "translate(-394.569 -414.153)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.6ab201eed551ddfa8311cdb31d9b4967.svg";
export { ForwardRef as ReactComponent };